import { StepConfig, WizardContext } from './types';
import { Card, List, ListItem, Typography } from '@mui/material';
import { CutCard } from './components/cut-card';
import {
  defaultWelcomeContent,
  defaultWelcomeTitle,
} from '../wizard-builder/wizard-builder';

export function createCutsheetSteps(
  ctx: WizardContext,
): StepConfig<WizardContext>[] {
  // Get active capability for this animal species and inspection level
  const activeCapability = (ctx.capabilities ?? []).find(
    (cap) =>
      cap?.animalSpecies === ctx.animalSpecies &&
      cap?.inspectionLevel === ctx.inspectionLevel,
  );

  // Use custom welcome message if available, otherwise use defaults
  const welcomeTitle =
    activeCapability?.wizardWelcomeTitle || defaultWelcomeTitle;
  const welcomeContent =
    activeCapability?.wizardWelcomeContent || defaultWelcomeContent;

  const steps: StepConfig<WizardContext>[] = [
    {
      id: 'intro' as const,
      title: welcomeTitle,
      subHead: '',
      instructions: '',
      content: (
        <Card
          sx={{
            backgroundColor: 'background.paper',
            borderRadius: '1rem',
            border: '1px solid',
            borderColor: 'divider',
            p: 3,
          }}
        >
          <Typography
            variant="body1"
            color="primary.main"
            sx={{ fontWeight: 400, whiteSpace: 'pre-line' }}
          >
            {welcomeContent}
          </Typography>
        </Card>
      ),
      canGoNext: (_c) => true,
    },
  ];

  return steps;
}
